import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

import { MESSAGE } from "@/constants/message";
import useToast, { EToastType } from "@/hooks/ui/useToast";
import { setLoadingOverlay } from "@/store/slice/uiSlice";

const useLoadingAndToast = () => {
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const setOverlay = (value: boolean) => {
    dispatch(setLoadingOverlay(value));
  };

  const showLoading = (
    message: string | React.ReactNode = MESSAGE.LOADING_GENERAL,
    useOverlay: boolean = true,
    id?: string
  ) => {
    if (useOverlay) setOverlay(true);
    showToast({ id, type: EToastType.LOADING, message });
  };

  const showSuccess = (
    message: string | React.ReactNode = MESSAGE.SUCCESS_GENERAL,
    closeOverlay: boolean = true
  ) => {
    if (closeOverlay) setOverlay(false);
    showToast({ type: EToastType.SUCCESS, message });
  };

  const showError = (
    message: string | React.ReactNode = MESSAGE.ERROR_GENERAL,
    closeOverlay: boolean = true
  ) => {
    if (closeOverlay) setOverlay(false);
    showToast({ type: EToastType.ERROR, message });
  };

  const showWarning = (
    message: string | React.ReactNode = MESSAGE.ERROR_GENERAL,
    closeOverlay: boolean = true
  ) => {
    if (closeOverlay) setOverlay(false);
    showToast({ type: EToastType.WARNING, message });
  };

  const removeToast = () => {
    toast.dismiss();
  };

  const clearLoadingState = () => {
    setOverlay(false);
    removeToast();
  };

  return {
    showLoading,
    showSuccess,
    showError,
    showWarning,
    removeToast,
    setOverlay,
    clearLoadingState
  };
};

export default useLoadingAndToast;
